import { AppState } from "app/shared/store/root.reducer";
import { createSelector } from "reselect";
const getStore = (state: AppState) => state.modal;

export const getModalStoreSelector = createSelector(getStore, (state) => state);
